<template>
  <component :is="componentType" v-model="isOpen" v-bind="$attrs">
    <slot/>
  </component>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();
const isOpen = defineModel();
const componentType = computed(() => (isMobile ? 'USlideover' : 'UModal'));

watch(isOpen, (open) => {
  if (open) {
    requestAnimationFrame(() => {
      const active = document.activeElement as HTMLElement | null
      if (active) {
        active.blur()
      }
    })
  }
})
</script>
